// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body {
  margin: 0;
  font-family: var(--slds-g-font-family-base);
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;

  --primary-color: var(--slds-g-color-palette-blue-50) !important;
}

.HomePageBody {
  margin-top: 48px;
  margin-bottom: 30px;
}

#Base {
  height: 100vh;
  display: flex;
}

#Base>div {
  overflow-y: auto;
}

.p-component {
  font-family: var(--slds-g-font-family-base);
  font-size: var(--slds-g-font-size-base, 0.8125rem);
}

.p-slider .p-slider-range {
  background: var(--slds-g-color-brand-base-50);
}

.p-slider .p-slider-handle {
  border-color: var(--slds-g-color-brand-base-50);
}

.p-slider:not(.p-disabled) .p-slider-handle:hover {
  background: var(--slds-g-color-brand-base-50);
}

.p-inputtext:enabled:focus {
  box-shadow: 0 0 0 0.1rem var(--slds-g-color-brand-base-50);
  border-color: var(--slds-g-color-brand-base-50);
}

.p-inputtext:enabled:hover {
  border-color: var(--slds-g-color-brand-base-50);
}

code {
  font-family: source-code-pro, Menlo, Monaco, Consolas, 'Courier New',
    monospace;
}

.Chatbot {
  /* height: 98vh;
  margin-top: 2px !important; */
  /* display: none;
  opacity: 0;
  transition: opacity 2s ease-in; */
}

.Chatbot .chatArea {
  height: 100%;
  box-shadow: var(--slds-g-shadow-6);
}

.Chatbot .chatArea .chatHeader {
  display: flex;
  align-items: center;
  border-bottom: 1px solid var(--slds-g-color-surface-inverse-1);
  padding-bottom: 4px;
}

.Chatbot .chatArea .chatHeader .closeButton {
  align-items: end;
}

.Chatbot .title {
  text-align: centre;
  font-size: large;
  color: var(--slds-g-color-surface-inverse-1);
  margin-left: 4px;
  font-weight: 500;

  /* background: var(--slds-g-color-surface-inverse-1);
  color: var(--slds-g-color-on-surface-inverse-1); */
}

.Chatbot .title>span {
  font-size: 12px;
}

.Chatbot .chatsContainer {
  /* height: 98%; */
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  background: transparent;
  border-radius: 0;
}

.Chatbot .chatsContainer .searchBox {
  box-shadow: var(--slds-g-shadow-6);
  border-radius: var(--slds-g-radius-border-2);
  width: 100%;
  /* position: absolute; */
  margin-bottom: 4px;

}

.Chatbot .chatsContainer .messagesArea {
  display: flex;
  flex-direction: column;
  overflow-y: scroll;
  height: 100%;
  background: transparent;
  overscroll-behavior-y: contain;
  scroll-snap-type: y proximity;
}

.messagesArea>div:last-child {
  scroll-snap-align: end;
  transition: 0.5s ease;
}

.Chatbot .chatsContainer .messagesArea .message {
  font-size: 14px;
  padding: 8px 12px;
  max-width: 75%;
  width: fit-content;
  white-space: pre-wrap;
  background: var(--slds-g-color-brand-base-50);
  color: var(--slds-g-color-on-accent-1);
}

.Chatbot .chatsContainer .messagesArea .message.system {
  background: var(--slds-g-color-surface-container-3);
  color: var(--slds-g-color-on-surface-2);
  align-self: flex-start;
}

.Chatbot .chatsContainer .messagesArea .message.user {
  align-self: flex-end;
}

.Chatbot .chatsContainer .messagesArea .message.user-image {
  background: #fff;
}

.Chatbot .chatsContainer .controlArea {
  padding-top: 12px;
}

.Chatbot .chatsContainer .controlArea .previewImage {
  border-color: var(--slds-g-color-brand-base-50);
  position: absolute;
  bottom: 55px;
  left: 16px;
}

.Chatbot .chatsContainer .controlArea .previewImageClose {
  position: absolute;
  bottom: 95px;
  left: 45px;
}

.Chatbot .chatsContainer .uploadFileBtn {
  position: absolute;
  bottom: 56px;
  right: 16px;
}

.Chatbot .chatsContainer .controlArea .sendBtn {
  background: var(--slds-g-color-brand-base-50);
  border-color: var(--slds-g-color-brand-base-50);
}

.agent-open .App {
  padding-right: 4px;
}

.agent-open .App .slds-global-header_container {
  position: static;
}

.agent-open .Chatbot {
  position: fixed;
  right: 0;
  margin-right: 0;
  display: block;
  opacity: 1;
}

.App .color-mode-controls {
  display: flex;
  position: absolute;
  z-index: 99;
  right: 10px;
  top: 60px;
  align-content: stretch;
  flex-direction: row;
  align-items: anchor-center;
}

.App .p-tabview-panels {
  padding: 16px 80px;
  background: var(--slds-g-color-surface-1);
}

.p-tabview .p-tabview-nav li.p-highlight .p-tabview-nav-link,
.p-inputswitch.p-highlight .p-inputswitch-slider {
  border-color: var(--slds-g-color-palette-blue-50);
  color: var(--slds-g-color-palette-blue-50);
}

.p-inputswitch.p-highlight .p-inputswitch-slider {
  background: var(--slds-g-color-palette-blue-50);
}

.slds-theming-scope {
  will-change: padding;
}

.slds-non-theming-scope {
  --slds-g-spacing-ratio: 1;
  --sds-g-spacing-1: var(--slds-g-spacing-1);
  --slds-g-spacing-1: calc(var(--slds-g-spacing-ratio) * 0.25rem);
  --sds-g-spacing-2: var(--slds-g-spacing-2);
  --slds-g-spacing-2: calc(var(--slds-g-spacing-ratio) * 0.5rem);
  --sds-g-spacing-3: var(--slds-g-spacing-3);
  --slds-g-spacing-3: calc(var(--slds-g-spacing-ratio) * 0.75rem);
  --sds-g-spacing-4: var(--slds-g-spacing-4);
  --slds-g-spacing-4: calc(var(--slds-g-spacing-ratio) * 1rem);
  --sds-g-spacing-5: var(--slds-g-spacing-5);
  --slds-g-spacing-5: calc(var(--slds-g-spacing-ratio) * 1.5rem);
  --sds-g-spacing-6: var(--slds-g-spacing-6);
  --slds-g-spacing-6: calc(var(--slds-g-spacing-ratio) * 2rem);
  --sds-g-spacing-7: var(--slds-g-spacing-7);
  --slds-g-spacing-7: calc(var(--slds-g-spacing-ratio) * 2.5rem);
  --sds-g-spacing-8: var(--slds-g-spacing-8);
  --slds-g-spacing-8: calc(var(--slds-g-spacing-ratio) * 3rem);
  --sds-g-spacing-9: var(--slds-g-spacing-9);
  --slds-g-spacing-9: calc(var(--slds-g-spacing-ratio) * 3.5rem);
  --sds-g-spacing-10: var(--slds-g-spacing-10);
  --slds-g-spacing-10: calc(var(--slds-g-spacing-ratio) * 4rem);
  --sds-g-spacing-11: var(--slds-g-spacing-11);
  --slds-g-spacing-11: calc(var(--slds-g-spacing-ratio) * 4.5rem);
  --sds-g-spacing-12: var(--slds-g-spacing-12);
  --slds-g-spacing-12: calc(var(--slds-g-spacing-ratio) * 5rem);
  --slds-g-sizing-border-ratio: 1;
  --sds-g-sizing-border-1: var(--slds-g-sizing-border-1);
  --slds-g-sizing-border-1: calc(var(--slds-g-sizing-border-ratio) * 1px);
  --sds-g-sizing-border-2: var(--slds-g-sizing-border-2);
  --slds-g-sizing-border-2: calc(var(--slds-g-sizing-border-ratio) * 2px);
  --sds-g-sizing-border-3: var(--slds-g-sizing-border-3);
  --slds-g-sizing-border-3: calc(var(--slds-g-sizing-border-ratio) * 3px);
  --sds-g-sizing-border-4: var(--slds-g-sizing-border-4);
  --slds-g-sizing-border-4: calc(var(--slds-g-sizing-border-ratio) * 4px);
  --slds-g-radius-border-ratio: 1;
  --sds-g-radius-border-1: var(--slds-g-radius-border-1);
  --slds-g-radius-border-1: calc(var(--slds-g-radius-border-ratio) * 0.25rem);
  --sds-g-radius-border-2: var(--slds-g-radius-border-2);
  --slds-g-radius-border-2: calc(var(--slds-g-radius-border-ratio) * 0.5rem);
  --sds-g-radius-border-3: var(--slds-g-radius-border-3);
  --slds-g-radius-border-3: calc(var(--slds-g-radius-border-ratio) * 0.75rem);
  --sds-g-radius-border-4: var(--slds-g-radius-border-4);
  --slds-g-radius-border-4: calc(var(--slds-g-radius-border-ratio) * 1.25rem);
  --slds-g-font-weight-ratio: 1;
  --sds-g-font-weight-bold: var(--slds-g-font-weight-bold);
  --slds-g-font-weight-bold: bold;
  --sds-g-font-weight-1: var(--slds-g-font-weight-1);
  --slds-g-font-weight-1: calc(var(--slds-g-font-weight-ratio) * 100);
  --sds-g-font-weight-2: var(--slds-g-font-weight-2);
  --slds-g-font-weight-2: calc(var(--slds-g-font-weight-ratio) * 200);
  --sds-g-font-weight-3: var(--slds-g-font-weight-3);
  --slds-g-font-weight-3: calc(var(--slds-g-font-weight-ratio) * 300);
  --sds-g-font-weight-4: var(--slds-g-font-weight-4);
  --slds-g-font-weight-4: calc(var(--slds-g-font-weight-ratio) * 400);
  --sds-g-font-weight-5: var(--slds-g-font-weight-5);
  --slds-g-font-weight-5: calc(var(--slds-g-font-weight-ratio) * 500);
  --sds-g-font-weight-6: var(--slds-g-font-weight-6);
  --slds-g-font-weight-6: calc(var(--slds-g-font-weight-ratio) * 600);
  --sds-g-font-weight-7: var(--slds-g-font-weight-7);
  --slds-g-font-weight-7: calc(var(--slds-g-font-weight-ratio) * 700);
  --slds-g-font-lineheight-ratio: 1;
  --sds-g-font-lineheight-base: var(--slds-g-font-lineheight-base);
  --slds-g-font-lineheight-base: 1.5;
  --sds-g-font-lineheight-1: var(--slds-g-font-lineheight-1);
  --slds-g-font-lineheight-1: calc(var(--slds-g-font-lineheight-ratio) * 1);
  --sds-g-font-lineheight-2: var(--slds-g-font-lineheight-2);
  --slds-g-font-lineheight-2: calc(var(--slds-g-font-lineheight-ratio) * 1.25);
  --sds-g-font-lineheight-3: var(--slds-g-font-lineheight-3);
  --slds-g-font-lineheight-3: calc(var(--slds-g-font-lineheight-ratio) * 1.375);
  --sds-g-font-lineheight-4: var(--slds-g-font-lineheight-4);
  --slds-g-font-lineheight-4: calc(var(--slds-g-font-lineheight-ratio) * 1.5);
  --sds-g-font-lineheight-5: var(--slds-g-font-lineheight-5);
  --slds-g-font-lineheight-5: calc(var(--slds-g-font-lineheight-ratio) * 1.75);
  --sds-g-font-lineheight-6: var(--slds-g-font-lineheight-6);
  --slds-g-font-lineheight-6: calc(var(--slds-g-font-lineheight-ratio) * 2);
  --sds-g-font-scale-ratio: var(--slds-g-font-scale-ratio);
  --slds-g-font-scale-ratio: 1;
  --sds-g-font-size-base: var(--slds-g-font-size-base);
  --slds-g-font-size-base: calc(var(--slds-g-font-scale-ratio) * 0.8125rem);
  --sds-g-font-scale-neg-4: var(--slds-g-font-scale-neg-4);
  --slds-g-font-scale-neg-4: var(--slds-g-font-scale-neg-3);
  --sds-g-font-scale-neg-3: var(--slds-g-font-scale-neg-3);
  --slds-g-font-scale-neg-3: var(--slds-g-font-scale-neg-2);
  --sds-g-font-scale-neg-2: var(--slds-g-font-scale-neg-2);
  --slds-g-font-scale-neg-2: calc(var(--slds-g-font-scale-ratio) * 0.625rem);
  --sds-g-font-scale-neg-1: var(--slds-g-font-scale-neg-1);
  --slds-g-font-scale-neg-1: calc(var(--slds-g-font-scale-ratio) * 0.75rem);
  --sds-g-font-scale-1: var(--slds-g-font-scale-1);
  --slds-g-font-scale-1: calc(var(--slds-g-font-scale-ratio) * 0.875rem);
  --sds-g-font-scale-2: var(--slds-g-font-scale-2);
  --slds-g-font-scale-2: calc(var(--slds-g-font-scale-ratio) * 1rem);
  --sds-g-font-scale-3: var(--slds-g-font-scale-3);
  --slds-g-font-scale-3: calc(var(--slds-g-font-scale-ratio) * 1.25rem);
  --sds-g-font-scale-4: var(--slds-g-font-scale-4);
  --slds-g-font-scale-4: calc(var(--slds-g-font-scale-ratio) * 1.5rem);
  --sds-g-font-scale-5: var(--slds-g-font-scale-5);
  --slds-g-font-scale-5: calc(var(--slds-g-font-scale-ratio) * 1.75rem);
  --sds-g-font-scale-6: var(--slds-g-font-scale-6);
  --slds-g-font-scale-6: calc(var(--slds-g-font-scale-ratio) * 2rem);
  --sds-g-font-scale-7: var(--slds-g-font-scale-7);
  --slds-g-font-scale-7: calc(var(--slds-g-font-scale-ratio) * 2.5rem);
  --sds-g-font-scale-8: var(--slds-g-font-scale-8);
  --slds-g-font-scale-8: calc(var(--slds-g-font-scale-ratio) * 3rem);
  --sds-g-font-scale-9: var(--slds-g-font-scale-9);
  --slds-g-font-scale-9: var(--slds-g-font-scale-8);
  --sds-g-font-scale-10: var(--slds-g-font-scale-10);
  --slds-g-font-scale-10: var(--slds-g-font-scale-8);

  --slds-s-link-color: #0250d9;
  --slds-s-link-color-hover: #022ac0;
  --slds-s-link-color-focus: #022ac0;
  --slds-s-link-color-active: #022ac0;

  --sds-g-font-family: var(--slds-g-font-family);
  --slds-g-font-family: var(--slds-g-font-family-base);
  --sds-g-font-family-base: var(--slds-g-font-family-base);
  --slds-g-font-family-base: system-ui, -apple-system, BlinkMacSystemFont, Segoe UI, Roboto, 'Helvetica Neue', Arial, sans-serif, 'Apple Color Emoji', 'Segoe UI Emoji', 'Segoe UI Symbol';

}


.site-options label {
  font-size: var(--sds-g-font-scale-neg-3);
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.05em;
}

.search input {
  background-color: var(--sds-g-color-surface-container-1);
  border: 1px solid var(--sds-g-color-border-1);
  width: 100%;
  border-radius: var(--sds-g-radius-border-2);
  padding: calc(var(--sds-g-spacing-1) + 1px) var(--sds-g-spacing-2);
}

.search input::placeholder {
  color: var(--sds-g-color-on-surface-1);
}

.search input:focus {
  outline: none;
  box-shadow: 0 0 2px var(--sds-g-color-accent-1);
  border-color: var(--sds-g-color-border-accent-1);
}

.hidden {
  display: none;
}

main {
  height: 100vh;
  width: 100vw;
  padding-top: var(--_header-height);

  @media (min-width: 768px) {
    display: grid;
    grid-template-columns: var(--_rail-width) 1fr;
    height: calc(100% - var(--_header-height));
    padding: 0;
  }
}

.source-btn {
  display: inline-flex;
  align-items: center;
  border: 1px solid black;
  font-size: var(--sds-g-font-scale-neg-1);
  background-color: var(--sds-g-color-neutral-base-10);
  color: var(--sds-g-color-neutral-base-100);
  border-radius: var(--sds-g-radius-border-2);
  padding-inline: var(--sds-g-spacing-3);
  padding-block: var(--sds-g-spacing-1);
  text-decoration: none;
  gap: var(--sds-g-spacing-1);

  --sds-c-icon-color-foreground: currentColor;
}

.canvas {
  padding: var(--sds-g-spacing-4) var(--sds-g-spacing-6);
  height: calc(100vh - var(--_header-height));
  width: 100%;
  overflow: auto;

  @media (min-width: 768px) {
    border-top-left-radius: var(--sds-g-radius-border-4);
  }
}

.canvas :where(h1, h2, h3, h4, h5, h6) {
  margin-block-start: var(--sds-g-spacing-3);
  margin-block-end: var(--sds-g-spacing-4);
  font-weight: 700;
}

.canvas h1 {
  font-size: var(--sds-g-font-scale-4);
  color: var(--sds-g-color-on-surface-3);
}

.canvas h2 {
  font-size: var(--sds-g-font-scale-3);
  color: var(--sds-g-color-on-surface-3);
}

.canvas h3 {
  font-size: var(--sds-g-font-scale-2);
  color: var(--sds-g-color-on-surface-3);
}

.canvas p:not([slot]) {
  margin-block-start: var(--sds-g-spacing-2);
  margin-block-end: var(--sds-g-spacing-4);
}

.canvas ol {
  list-style: decimal;
  padding-left: 1rem;
  margin-bottom: var(--sds-g-spacing-4);
}

.canvas pre {
  margin-block-start: var(--sds-g-spacing-2);
  margin-block-end: var(--sds-g-spacing-4);
  padding: var(--sds-g-spacing-4);
  border-radius: var(--sds-g-radius-border-3);
  font-size: var(--sds-g-font-scale-neg-1);
  max-width: calc(100vw - var(--sds-g-spacing-6) * 2);

  @media (min-width: 768px) {
    max-width: 120ch;
  }
}

.page-header {
  text-transform: capitalize;
  padding-block-end: var(--sds-g-spacing-4);
  margin-block-end: var(--sds-g-spacing-4);

  @media (min-width: 768px) {
    display: flex;
    align-items: center;
    gap: 1.62rem;
  }
}

.page-header h2 {
  margin-inline-end: auto;
  margin-block: 0;
  font-size: var(--sds-g-font-scale-5);
}

.mobile-menu {
  display: none;
}

@media (max-width: 768px) {
  .header {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    background-color: var(--sds-g-color-surface-1);
  }

  .header-right {
    display: none;
  }

  .mobile-menu {
    display: flex;
    justify-content: center;
    align-items: center;
    position: relative;
    z-index: 3;
    width: 40px;
    height: 40px;
    padding: 0;
    border: 0;
    background-color: transparent;
    cursor: pointer;
    flex: 0 0 auto;
    margin-inline-start: auto;
  }
}

.site-rail {
  display: flex;
  flex-direction: column;
  padding: var(--sds-g-spacing-4) var(--sds-g-spacing-4) 0;
  height: calc(100vh - var(--_header-height));

  @media (max-width: 768px) {
    position: fixed;
    top: var(--_header-height);
    right: 0;
    width: 80vw;
    height: calc(100vh - var(--_header-height));
    z-index: 2;
    background-color: var(--sds-g-color-surface-1);
    transform: translateX(100%);
    box-shadow: var(--sds-g-shadow-4);
    transition: transform 0.2s ease-in-out;
  }
}

.nav {
  display: flex;
  flex-direction: column;
  padding: 0 var(--sds-g-spacing-4) var(--sds-g-spacing-4);
  overflow-y: auto;
  margin-inline: calc(var(--sds-g-spacing-4) * -1);
}

.nav-open .site-rail {
  transform: translateX(0);
}

.nav>p {
  margin-block-start: var(--sds-g-spacing-4);
  margin-block-end: var(--sds-g-spacing-4);
  font-weight: 700;
  color: var(--sds-g-color-on-surface-3);
}

.nav li {
  border-radius: var(--sds-g-radius-border-3);
}

.nav li+li {
  margin-block-start: var(--sds-g-spacing-2);
}

.nav a {
  display: block;
  padding: var(--sds-g-spacing-2) var(--sds-g-spacing-4);
  color: var(--sds-g-color-on-surface-2);
  text-decoration: none;
  border-radius: var(--sds-g-radius-border-3);
  transition: background-color 0.2s ease-in-out;
}

.nav a:hover {
  background-color: var(--sds-g-color-surface-3);
}

.nav .active,
.nav .active a {
  background-color: var(--sds-g-color-surface-1);
}

/*
 * ------------------
 * Styling Hook Stuff
 * ------------------
 */
.styling-hooks :where(h2, h3, h4) {
  margin-block-start: var(--sds-g-spacing-6);
  margin-block-end: var(--sds-g-spacing-4);
}

.styling-hooks :where(h1, h2, h3, h4) {
  color: light-dark(#000, #fff);
}

.ui-colors [data-value] {
  --shadow1: light-dark(#18181808, #78727208);
  --shadow2: light-dark(#18181810, #ada0a015);
  --shadow3: light-dark(#18181815, #ada0a015);
  border-radius: 8px;
  box-shadow: 0px 3px 5px -2px var(--shadow1), 0px 7px 14px -5px var(--shadow2), 0 0 0 1px inset var(--shadow3);
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
  align-items: center;
  justify-content: center;
  text-align: center;
  font-size: var(--sds-g-font-scale-neg-3);
  font-family: var(--sds-g-font-family-monospace);
}

/* Surface Colors */
.surface-colors {
  display: grid;
  grid-template-columns: repeat(6, minmax(var(--sds-g-sizing-10), 1fr));
  grid-template-rows: repeat(3, var(--sds-g-sizing-11));
  gap: 1rem;
}

.surface-colors .on-surface {
  grid-row-start: 1;
  grid-column: 1 / span 6;
  display: grid;
  grid-template-columns: repeat(5, minmax(0, 1fr));
  gap: 1rem;
}

.surface-colors .surfaces {
  grid-row-start: 3;
  grid-column: 1 / span 6;
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 1rem;
}

.surface-colors .surface-containers {
  grid-row-start: 2;
  grid-column: 1 / span 6;
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 1rem;
}

/* Accents Colors */
.accent-colors {
  display: grid;
  grid-template-columns: repeat(4, minmax(var(--sds-g-sizing-10), 1fr));
  /* grid-template-rows: repeat(4, var(--sds-g-sizing-11)); */
  gap: 1rem;
}

.accent-colors>div {
  display: flex;
  flex-direction: column;
  gap: 1rem;
}

.accent-colors [data-value] {
  flex: 0 0 var(--sds-g-sizing-11);
}

/* Feedback Colors */
.feedback-colors {
  display: grid;
  grid-template-columns: repeat(4, minmax(var(--sds-g-sizing-10), 1fr));
  gap: 1rem;
}

.feedback-colors>div {
  display: flex;
  flex-direction: column;
  gap: 1rem;
}

.feedback-colors p {
  font-size: var(--sds-g-font-scale-neg-2);
}

.feedback-colors [data-value] {
  flex: 0 0 var(--sds-g-sizing-11);
}

/* Element Colors */
.element-colors {
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: 1rem;
}

.element-colors>div {
  display: flex;
  flex-direction: column;
  gap: 1rem;
}

.element-colors [data-value] {
  flex: 0 0 var(--sds-g-sizing-11);
}

/* System Colors */
.system-colors [data-value],
.color-palettes [data-value] {
  border-radius: 8px;
  box-shadow: var(--sds-g-shadow-2), 0 0 0 1px inset #18181815;
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  padding: 0 var(--sds-g-spacing-2);
  font-size: var(--sds-g-font-scale-neg-3);
  font-family: var(--sds-g-font-family-monospace);
  aspect-ratio: var(--sds-g-ratio-square);

  @media (min-width: 768px) {
    aspect-ratio: var(--sds-g-ratio-landscape);
  }

  @media (min-width: 1024px) {
    aspect-ratio: var(--sds-g-ratio-square);
  }
}

.system-colors {
  display: grid;
  grid-template-columns: repeat(6, minmax(0, 1fr));
  gap: 1rem;

  @media (min-width: 1280px) {
    grid-template-columns: repeat(13, minmax(0, 1fr));
  }
}

.system-colors.feedback {
  grid-template-columns: repeat(5, minmax(0, 1fr));

  @media (min-width: 1024px) {
    grid-template-columns: repeat(10, minmax(0, 1fr));
  }
}

/* Color Palettes */
.color-palettes {
  display: grid;
  grid-template-columns: repeat(6, minmax(0, 1fr));
  gap: 1rem;
  margin-block: 1rem;

  @media (min-width: 1024px) {
    grid-template-columns: repeat(12, minmax(0, 1fr));
  }
}

/* Shadows, Border Widths, Border Radius */
.shadow,
.border-width {
  display: flex;
  gap: 1rem;
}

.border-radius {
  display: grid;
  grid-template-columns: repeat(5, 1fr);
  grid-template-rows: 1fr var(--sds-g-sizing-9);
  gap: 1rem;
}

.shadow [data-value],
.border-width [data-value],
.border-radius [data-value] {
  background: var(--sds-g-color-surface-container-1);
  border-radius: 8px;
  display: flex;
  flex-direction: column;
  gap: 0.125rem;
  align-items: center;
  justify-content: center;
  text-align: center;
  flex: 1 1;
  font-size: var(--sds-g-font-scale-neg-3);
  font-family: var(--sds-g-font-family-monospace);
  aspect-ratio: var(--sds-g-ratio-square);
}

.shadow [data-value],
.border-width [data-value] {
  @media (min-width: 1280px) {
    aspect-ratio: var(--sds-g-ratio-landscape);
  }
}

.border-width div,
.border-radius div {
  border: 1px solid var(--sds-g-color-border-1);
}

.border-radius .border-pill {
  height: var(--sds-g-sizing-9);
  aspect-ratio: unset;
}

/* Font */
.line-height>p {
  max-inline-size: var(--sds-g-sizing-content-2);
}

.font-size [data-value] {
  line-height: 1.15;
}

.font-size [data-value],
.font-weight [data-value],
.line-height [data-value] {
  display: grid;
  grid-template-columns: minmax(max-content, 100px) 1fr;
  gap: 1rem;
  margin-block: var(--sds-g-spacing-2);
}

.font-size [data-value]:before,
.font-weight [data-value]:before,
.line-height [data-value]:before {
  content: attr(data-size);
  font-size: var(--sds-g-font-scale-neg-3);
  font-family: var(--sds-g-font-family-monospace);
  font-weight: normal;
  text-align: right;
  align-self: center;
}

/* Spacing, Sizing */
.spacing [data-value],
.sizing [data-value] {
  display: grid;
  grid-template-columns: minmax(max-content, 100px) 1fr;
  gap: 1rem;
  margin-block: var(--sds-g-spacing-2);
}

.spacing [data-value]:before,
.sizing [data-value]:before {
  content: attr(data-size);
  font-size: var(--sds-g-font-scale-neg-3);
  font-family: var(--sds-g-font-family-monospace);
  font-weight: normal;
  text-align: right;
  align-self: center;
}

.spacing [data-value]>div,
.sizing [data-value]>div {
  background-color: var(--sds-g-color-surface-container-3);
}

/* Content Sizing */
.content-sizing {
  display: grid;
  grid-template-columns: repeat(1, minmax(0, 1fr));

  @media (min-width: 1024px) {
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }
}

.content-sizing>div {
  display: flex;
  flex-direction: column;
  gap: 1rem;
}

.content-sizing>div:before {
  content: attr(data-prop) ' : ' attr(data-size);
  font-size: var(--sds-g-font-scale-neg-3);
  font-family: var(--sds-g-font-family-monospace);
}

.byline {
  display: flex;
  flex-direction: column;
}

.byline_title {
  font-size: var(--sds-g-font-scale-neg-3);
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.05em;
}

.byline [title] {
  -webkit-text-decoration: underline dotted;
          text-decoration: underline dotted;
  cursor: help;
}

.byline a {
  color: var(--sds-g-color-accent-2);
}`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AAAA;EACE,SAAS;EACT,2CAA2C;EAC3C,mCAAmC;EACnC,kCAAkC;;EAElC,+DAA+D;AACjE;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,aAAa;AACf;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,2CAA2C;EAC3C,kDAAkD;AACpD;;AAEA;EACE,6CAA6C;AAC/C;;AAEA;EACE,+CAA+C;AACjD;;AAEA;EACE,6CAA6C;AAC/C;;AAEA;EACE,0DAA0D;EAC1D,+CAA+C;AACjD;;AAEA;EACE,+CAA+C;AACjD;;AAEA;EACE;aACW;AACb;;AAEA;EACE;+BAC6B;EAC7B;;mCAEiC;AACnC;;AAEA;EACE,YAAY;EACZ,kCAAkC;AACpC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8DAA8D;EAC9D,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,4CAA4C;EAC5C,gBAAgB;EAChB,gBAAgB;;EAEhB;oDACkD;AACpD;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,sBAAsB;EACtB,8BAA8B;EAC9B,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,kCAAkC;EAClC,4CAA4C;EAC5C,WAAW;EACX,wBAAwB;EACxB,kBAAkB;;AAEpB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,kBAAkB;EAClB,YAAY;EACZ,uBAAuB;EACvB,8BAA8B;EAC9B,6BAA6B;AAC/B;;AAEA;EACE,sBAAsB;EACtB,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,kBAAkB;EAClB,qBAAqB;EACrB,6CAA6C;EAC7C,sCAAsC;AACxC;;AAEA;EACE,mDAAmD;EACnD,uCAAuC;EACvC,sBAAsB;AACxB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,+CAA+C;EAC/C,kBAAkB;EAClB,YAAY;EACZ,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,6CAA6C;EAC7C,+CAA+C;AACjD;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,QAAQ;EACR,eAAe;EACf,cAAc;EACd,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,WAAW;EACX,WAAW;EACX,SAAS;EACT,sBAAsB;EACtB,mBAAmB;EACnB,0BAA0B;AAC5B;;AAEA;EACE,kBAAkB;EAClB,yCAAyC;AAC3C;;AAEA;;EAEE,iDAAiD;EACjD,0CAA0C;AAC5C;;AAEA;EACE,+CAA+C;AACjD;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,yBAAyB;EACzB,0CAA0C;EAC1C,+DAA+D;EAC/D,0CAA0C;EAC1C,8DAA8D;EAC9D,0CAA0C;EAC1C,+DAA+D;EAC/D,0CAA0C;EAC1C,4DAA4D;EAC5D,0CAA0C;EAC1C,8DAA8D;EAC9D,0CAA0C;EAC1C,4DAA4D;EAC5D,0CAA0C;EAC1C,8DAA8D;EAC9D,0CAA0C;EAC1C,4DAA4D;EAC5D,0CAA0C;EAC1C,8DAA8D;EAC9D,4CAA4C;EAC5C,6DAA6D;EAC7D,4CAA4C;EAC5C,+DAA+D;EAC/D,4CAA4C;EAC5C,6DAA6D;EAC7D,+BAA+B;EAC/B,sDAAsD;EACtD,uEAAuE;EACvE,sDAAsD;EACtD,uEAAuE;EACvE,sDAAsD;EACtD,uEAAuE;EACvE,sDAAsD;EACtD,uEAAuE;EACvE,+BAA+B;EAC/B,sDAAsD;EACtD,2EAA2E;EAC3E,sDAAsD;EACtD,0EAA0E;EAC1E,sDAAsD;EACtD,2EAA2E;EAC3E,sDAAsD;EACtD,2EAA2E;EAC3E,6BAA6B;EAC7B,wDAAwD;EACxD,+BAA+B;EAC/B,kDAAkD;EAClD,mEAAmE;EACnE,kDAAkD;EAClD,mEAAmE;EACnE,kDAAkD;EAClD,mEAAmE;EACnE,kDAAkD;EAClD,mEAAmE;EACnE,kDAAkD;EAClD,mEAAmE;EACnE,kDAAkD;EAClD,mEAAmE;EACnE,kDAAkD;EAClD,mEAAmE;EACnE,iCAAiC;EACjC,gEAAgE;EAChE,kCAAkC;EAClC,0DAA0D;EAC1D,yEAAyE;EACzE,0DAA0D;EAC1D,4EAA4E;EAC5E,0DAA0D;EAC1D,6EAA6E;EAC7E,0DAA0D;EAC1D,2EAA2E;EAC3E,0DAA0D;EAC1D,4EAA4E;EAC5E,0DAA0D;EAC1D,yEAAyE;EACzE,wDAAwD;EACxD,4BAA4B;EAC5B,oDAAoD;EACpD,yEAAyE;EACzE,wDAAwD;EACxD,yDAAyD;EACzD,wDAAwD;EACxD,yDAAyD;EACzD,wDAAwD;EACxD,0EAA0E;EAC1E,wDAAwD;EACxD,yEAAyE;EACzE,gDAAgD;EAChD,sEAAsE;EACtE,gDAAgD;EAChD,kEAAkE;EAClE,gDAAgD;EAChD,qEAAqE;EACrE,gDAAgD;EAChD,oEAAoE;EACpE,gDAAgD;EAChD,qEAAqE;EACrE,gDAAgD;EAChD,kEAAkE;EAClE,gDAAgD;EAChD,oEAAoE;EACpE,gDAAgD;EAChD,kEAAkE;EAClE,gDAAgD;EAChD,iDAAiD;EACjD,kDAAkD;EAClD,kDAAkD;;EAElD,4BAA4B;EAC5B,kCAAkC;EAClC,kCAAkC;EAClC,mCAAmC;;EAEnC,8CAA8C;EAC9C,oDAAoD;EACpD,wDAAwD;EACxD,wLAAwL;;AAE1L;;;AAGA;EACE,wCAAwC;EACxC,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,wDAAwD;EACxD,6CAA6C;EAC7C,WAAW;EACX,2CAA2C;EAC3C,kEAAkE;AACpE;;AAEA;EACE,sCAAsC;AACxC;;AAEA;EACE,aAAa;EACb,+CAA+C;EAC/C,gDAAgD;AAClD;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,kCAAkC;;EAElC;IACE,aAAa;IACb,6CAA6C;IAC7C,0CAA0C;IAC1C,UAAU;EACZ;AACF;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,wCAAwC;EACxC,oDAAoD;EACpD,0CAA0C;EAC1C,2CAA2C;EAC3C,sCAAsC;EACtC,qCAAqC;EACrC,qBAAqB;EACrB,2BAA2B;;EAE3B,2CAA2C;AAC7C;;AAEA;EACE,sDAAsD;EACtD,2CAA2C;EAC3C,WAAW;EACX,cAAc;;EAEd;IACE,oDAAoD;EACtD;AACF;;AAEA;EACE,0CAA0C;EAC1C,wCAAwC;EACxC,gBAAgB;AAClB;;AAEA;EACE,oCAAoC;EACpC,sCAAsC;AACxC;;AAEA;EACE,oCAAoC;EACpC,sCAAsC;AACxC;;AAEA;EACE,oCAAoC;EACpC,sCAAsC;AACxC;;AAEA;EACE,0CAA0C;EAC1C,wCAAwC;AAC1C;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,qCAAqC;AACvC;;AAEA;EACE,0CAA0C;EAC1C,wCAAwC;EACxC,+BAA+B;EAC/B,2CAA2C;EAC3C,wCAAwC;EACxC,mDAAmD;;EAEnD;IACE,gBAAgB;EAClB;AACF;;AAEA;EACE,0BAA0B;EAC1B,yCAAyC;EACzC,wCAAwC;;EAExC;IACE,aAAa;IACb,mBAAmB;IACnB,YAAY;EACd;AACF;;AAEA;EACE,uBAAuB;EACvB,eAAe;EACf,oCAAoC;AACtC;;AAEA;EACE,aAAa;AACf;;AAEA;EACE;IACE,eAAe;IACf,MAAM;IACN,OAAO;IACP,QAAQ;IACR,8CAA8C;EAChD;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,kBAAkB;IAClB,UAAU;IACV,WAAW;IACX,YAAY;IACZ,UAAU;IACV,SAAS;IACT,6BAA6B;IAC7B,eAAe;IACf,cAAc;IACd,yBAAyB;EAC3B;AACF;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,wDAAwD;EACxD,2CAA2C;;EAE3C;IACE,eAAe;IACf,0BAA0B;IAC1B,QAAQ;IACR,WAAW;IACX,2CAA2C;IAC3C,UAAU;IACV,8CAA8C;IAC9C,2BAA2B;IAC3B,iCAAiC;IACjC,sCAAsC;EACxC;AACF;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,wDAAwD;EACxD,gBAAgB;EAChB,gDAAgD;AAClD;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,0CAA0C;EAC1C,wCAAwC;EACxC,gBAAgB;EAChB,sCAAsC;AACxC;;AAEA;EACE,2CAA2C;AAC7C;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE,cAAc;EACd,sDAAsD;EACtD,sCAAsC;EACtC,qBAAqB;EACrB,2CAA2C;EAC3C,6CAA6C;AAC/C;;AAEA;EACE,8CAA8C;AAChD;;AAEA;;EAEE,8CAA8C;AAChD;;AAEA;;;;EAIE;AACF;EACE,0CAA0C;EAC1C,wCAAwC;AAC1C;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,2CAA2C;EAC3C,2CAA2C;EAC3C,2CAA2C;EAC3C,kBAAkB;EAClB,6GAA6G;EAC7G,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,wCAAwC;EACxC,+CAA+C;AACjD;;AAEA,mBAAmB;AACnB;EACE,aAAa;EACb,qEAAqE;EACrE,qDAAqD;EACrD,SAAS;AACX;;AAEA;EACE,iBAAiB;EACjB,uBAAuB;EACvB,aAAa;EACb,gDAAgD;EAChD,SAAS;AACX;;AAEA;EACE,iBAAiB;EACjB,uBAAuB;EACvB,aAAa;EACb,gDAAgD;EAChD,SAAS;AACX;;AAEA;EACE,iBAAiB;EACjB,uBAAuB;EACvB,aAAa;EACb,gDAAgD;EAChD,SAAS;AACX;;AAEA,mBAAmB;AACnB;EACE,aAAa;EACb,qEAAqE;EACrE,2DAA2D;EAC3D,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,gCAAgC;AAClC;;AAEA,oBAAoB;AACpB;EACE,aAAa;EACb,qEAAqE;EACrE,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EACE,gCAAgC;AAClC;;AAEA,mBAAmB;AACnB;EACE,aAAa;EACb,gDAAgD;EAChD,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,gCAAgC;AAClC;;AAEA,kBAAkB;AAClB;;EAEE,kBAAkB;EAClB,4DAA4D;EAC5D,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,iCAAiC;EACjC,wCAAwC;EACxC,+CAA+C;EAC/C,uCAAuC;;EAEvC;IACE,0CAA0C;EAC5C;;EAEA;IACE,uCAAuC;EACzC;AACF;;AAEA;EACE,aAAa;EACb,gDAAgD;EAChD,SAAS;;EAET;IACE,iDAAiD;EACnD;AACF;;AAEA;EACE,gDAAgD;;EAEhD;IACE,iDAAiD;EACnD;AACF;;AAEA,mBAAmB;AACnB;EACE,aAAa;EACb,gDAAgD;EAChD,SAAS;EACT,kBAAkB;;EAElB;IACE,iDAAiD;EACnD;AACF;;AAEA,0CAA0C;AAC1C;;EAEE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,6CAA6C;EAC7C,SAAS;AACX;;AAEA;;;EAGE,kDAAkD;EAClD,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,SAAO;EACP,wCAAwC;EACxC,+CAA+C;EAC/C,uCAAuC;AACzC;;AAEA;;EAEE;IACE,0CAA0C;EAC5C;AACF;;AAEA;;EAEE,6CAA6C;AAC/C;;AAEA;EACE,6BAA6B;EAC7B,mBAAmB;AACrB;;AAEA,SAAS;AACT;EACE,8CAA8C;AAChD;;AAEA;EACE,iBAAiB;AACnB;;AAEA;;;EAGE,aAAa;EACb,qDAAqD;EACrD,SAAS;EACT,oCAAoC;AACtC;;AAEA;;;EAGE,wBAAwB;EACxB,wCAAwC;EACxC,+CAA+C;EAC/C,mBAAmB;EACnB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA,oBAAoB;AACpB;;EAEE,aAAa;EACb,qDAAqD;EACrD,SAAS;EACT,oCAAoC;AACtC;;AAEA;;EAEE,wBAAwB;EACxB,wCAAwC;EACxC,+CAA+C;EAC/C,mBAAmB;EACnB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;;EAEE,wDAAwD;AAC1D;;AAEA,mBAAmB;AACnB;EACE,aAAa;EACb,gDAAgD;;EAEhD;IACE,gDAAgD;EAClD;AACF;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,8CAA8C;EAC9C,wCAAwC;EACxC,+CAA+C;AACjD;;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,wCAAwC;EACxC,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,yCAAiC;UAAjC,iCAAiC;EACjC,YAAY;AACd;;AAEA;EACE,kCAAkC;AACpC","sourcesContent":["body {\n  margin: 0;\n  font-family: var(--slds-g-font-family-base);\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n\n  --primary-color: var(--slds-g-color-palette-blue-50) !important;\n}\n\n.HomePageBody {\n  margin-top: 48px;\n  margin-bottom: 30px;\n}\n\n#Base {\n  height: 100vh;\n  display: flex;\n}\n\n#Base>div {\n  overflow-y: auto;\n}\n\n.p-component {\n  font-family: var(--slds-g-font-family-base);\n  font-size: var(--slds-g-font-size-base, 0.8125rem);\n}\n\n.p-slider .p-slider-range {\n  background: var(--slds-g-color-brand-base-50);\n}\n\n.p-slider .p-slider-handle {\n  border-color: var(--slds-g-color-brand-base-50);\n}\n\n.p-slider:not(.p-disabled) .p-slider-handle:hover {\n  background: var(--slds-g-color-brand-base-50);\n}\n\n.p-inputtext:enabled:focus {\n  box-shadow: 0 0 0 0.1rem var(--slds-g-color-brand-base-50);\n  border-color: var(--slds-g-color-brand-base-50);\n}\n\n.p-inputtext:enabled:hover {\n  border-color: var(--slds-g-color-brand-base-50);\n}\n\ncode {\n  font-family: source-code-pro, Menlo, Monaco, Consolas, 'Courier New',\n    monospace;\n}\n\n.Chatbot {\n  /* height: 98vh;\n  margin-top: 2px !important; */\n  /* display: none;\n  opacity: 0;\n  transition: opacity 2s ease-in; */\n}\n\n.Chatbot .chatArea {\n  height: 100%;\n  box-shadow: var(--slds-g-shadow-6);\n}\n\n.Chatbot .chatArea .chatHeader {\n  display: flex;\n  align-items: center;\n  border-bottom: 1px solid var(--slds-g-color-surface-inverse-1);\n  padding-bottom: 4px;\n}\n\n.Chatbot .chatArea .chatHeader .closeButton {\n  align-items: end;\n}\n\n.Chatbot .title {\n  text-align: centre;\n  font-size: large;\n  color: var(--slds-g-color-surface-inverse-1);\n  margin-left: 4px;\n  font-weight: 500;\n\n  /* background: var(--slds-g-color-surface-inverse-1);\n  color: var(--slds-g-color-on-surface-inverse-1); */\n}\n\n.Chatbot .title>span {\n  font-size: 12px;\n}\n\n.Chatbot .chatsContainer {\n  /* height: 98%; */\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n  background: transparent;\n  border-radius: 0;\n}\n\n.Chatbot .chatsContainer .searchBox {\n  box-shadow: var(--slds-g-shadow-6);\n  border-radius: var(--slds-g-radius-border-2);\n  width: 100%;\n  /* position: absolute; */\n  margin-bottom: 4px;\n\n}\n\n.Chatbot .chatsContainer .messagesArea {\n  display: flex;\n  flex-direction: column;\n  overflow-y: scroll;\n  height: 100%;\n  background: transparent;\n  overscroll-behavior-y: contain;\n  scroll-snap-type: y proximity;\n}\n\n.messagesArea>div:last-child {\n  scroll-snap-align: end;\n  transition: 0.5s ease;\n}\n\n.Chatbot .chatsContainer .messagesArea .message {\n  font-size: 14px;\n  padding: 8px 12px;\n  max-width: 75%;\n  width: fit-content;\n  white-space: pre-wrap;\n  background: var(--slds-g-color-brand-base-50);\n  color: var(--slds-g-color-on-accent-1);\n}\n\n.Chatbot .chatsContainer .messagesArea .message.system {\n  background: var(--slds-g-color-surface-container-3);\n  color: var(--slds-g-color-on-surface-2);\n  align-self: flex-start;\n}\n\n.Chatbot .chatsContainer .messagesArea .message.user {\n  align-self: flex-end;\n}\n\n.Chatbot .chatsContainer .messagesArea .message.user-image {\n  background: #fff;\n}\n\n.Chatbot .chatsContainer .controlArea {\n  padding-top: 12px;\n}\n\n.Chatbot .chatsContainer .controlArea .previewImage {\n  border-color: var(--slds-g-color-brand-base-50);\n  position: absolute;\n  bottom: 55px;\n  left: 16px;\n}\n\n.Chatbot .chatsContainer .controlArea .previewImageClose {\n  position: absolute;\n  bottom: 95px;\n  left: 45px;\n}\n\n.Chatbot .chatsContainer .uploadFileBtn {\n  position: absolute;\n  bottom: 56px;\n  right: 16px;\n}\n\n.Chatbot .chatsContainer .controlArea .sendBtn {\n  background: var(--slds-g-color-brand-base-50);\n  border-color: var(--slds-g-color-brand-base-50);\n}\n\n.agent-open .App {\n  padding-right: 4px;\n}\n\n.agent-open .App .slds-global-header_container {\n  position: static;\n}\n\n.agent-open .Chatbot {\n  position: fixed;\n  right: 0;\n  margin-right: 0;\n  display: block;\n  opacity: 1;\n}\n\n.App .color-mode-controls {\n  display: flex;\n  position: absolute;\n  z-index: 99;\n  right: 10px;\n  top: 60px;\n  align-content: stretch;\n  flex-direction: row;\n  align-items: anchor-center;\n}\n\n.App .p-tabview-panels {\n  padding: 16px 80px;\n  background: var(--slds-g-color-surface-1);\n}\n\n.p-tabview .p-tabview-nav li.p-highlight .p-tabview-nav-link,\n.p-inputswitch.p-highlight .p-inputswitch-slider {\n  border-color: var(--slds-g-color-palette-blue-50);\n  color: var(--slds-g-color-palette-blue-50);\n}\n\n.p-inputswitch.p-highlight .p-inputswitch-slider {\n  background: var(--slds-g-color-palette-blue-50);\n}\n\n.slds-theming-scope {\n  will-change: padding;\n}\n\n.slds-non-theming-scope {\n  --slds-g-spacing-ratio: 1;\n  --sds-g-spacing-1: var(--slds-g-spacing-1);\n  --slds-g-spacing-1: calc(var(--slds-g-spacing-ratio) * 0.25rem);\n  --sds-g-spacing-2: var(--slds-g-spacing-2);\n  --slds-g-spacing-2: calc(var(--slds-g-spacing-ratio) * 0.5rem);\n  --sds-g-spacing-3: var(--slds-g-spacing-3);\n  --slds-g-spacing-3: calc(var(--slds-g-spacing-ratio) * 0.75rem);\n  --sds-g-spacing-4: var(--slds-g-spacing-4);\n  --slds-g-spacing-4: calc(var(--slds-g-spacing-ratio) * 1rem);\n  --sds-g-spacing-5: var(--slds-g-spacing-5);\n  --slds-g-spacing-5: calc(var(--slds-g-spacing-ratio) * 1.5rem);\n  --sds-g-spacing-6: var(--slds-g-spacing-6);\n  --slds-g-spacing-6: calc(var(--slds-g-spacing-ratio) * 2rem);\n  --sds-g-spacing-7: var(--slds-g-spacing-7);\n  --slds-g-spacing-7: calc(var(--slds-g-spacing-ratio) * 2.5rem);\n  --sds-g-spacing-8: var(--slds-g-spacing-8);\n  --slds-g-spacing-8: calc(var(--slds-g-spacing-ratio) * 3rem);\n  --sds-g-spacing-9: var(--slds-g-spacing-9);\n  --slds-g-spacing-9: calc(var(--slds-g-spacing-ratio) * 3.5rem);\n  --sds-g-spacing-10: var(--slds-g-spacing-10);\n  --slds-g-spacing-10: calc(var(--slds-g-spacing-ratio) * 4rem);\n  --sds-g-spacing-11: var(--slds-g-spacing-11);\n  --slds-g-spacing-11: calc(var(--slds-g-spacing-ratio) * 4.5rem);\n  --sds-g-spacing-12: var(--slds-g-spacing-12);\n  --slds-g-spacing-12: calc(var(--slds-g-spacing-ratio) * 5rem);\n  --slds-g-sizing-border-ratio: 1;\n  --sds-g-sizing-border-1: var(--slds-g-sizing-border-1);\n  --slds-g-sizing-border-1: calc(var(--slds-g-sizing-border-ratio) * 1px);\n  --sds-g-sizing-border-2: var(--slds-g-sizing-border-2);\n  --slds-g-sizing-border-2: calc(var(--slds-g-sizing-border-ratio) * 2px);\n  --sds-g-sizing-border-3: var(--slds-g-sizing-border-3);\n  --slds-g-sizing-border-3: calc(var(--slds-g-sizing-border-ratio) * 3px);\n  --sds-g-sizing-border-4: var(--slds-g-sizing-border-4);\n  --slds-g-sizing-border-4: calc(var(--slds-g-sizing-border-ratio) * 4px);\n  --slds-g-radius-border-ratio: 1;\n  --sds-g-radius-border-1: var(--slds-g-radius-border-1);\n  --slds-g-radius-border-1: calc(var(--slds-g-radius-border-ratio) * 0.25rem);\n  --sds-g-radius-border-2: var(--slds-g-radius-border-2);\n  --slds-g-radius-border-2: calc(var(--slds-g-radius-border-ratio) * 0.5rem);\n  --sds-g-radius-border-3: var(--slds-g-radius-border-3);\n  --slds-g-radius-border-3: calc(var(--slds-g-radius-border-ratio) * 0.75rem);\n  --sds-g-radius-border-4: var(--slds-g-radius-border-4);\n  --slds-g-radius-border-4: calc(var(--slds-g-radius-border-ratio) * 1.25rem);\n  --slds-g-font-weight-ratio: 1;\n  --sds-g-font-weight-bold: var(--slds-g-font-weight-bold);\n  --slds-g-font-weight-bold: bold;\n  --sds-g-font-weight-1: var(--slds-g-font-weight-1);\n  --slds-g-font-weight-1: calc(var(--slds-g-font-weight-ratio) * 100);\n  --sds-g-font-weight-2: var(--slds-g-font-weight-2);\n  --slds-g-font-weight-2: calc(var(--slds-g-font-weight-ratio) * 200);\n  --sds-g-font-weight-3: var(--slds-g-font-weight-3);\n  --slds-g-font-weight-3: calc(var(--slds-g-font-weight-ratio) * 300);\n  --sds-g-font-weight-4: var(--slds-g-font-weight-4);\n  --slds-g-font-weight-4: calc(var(--slds-g-font-weight-ratio) * 400);\n  --sds-g-font-weight-5: var(--slds-g-font-weight-5);\n  --slds-g-font-weight-5: calc(var(--slds-g-font-weight-ratio) * 500);\n  --sds-g-font-weight-6: var(--slds-g-font-weight-6);\n  --slds-g-font-weight-6: calc(var(--slds-g-font-weight-ratio) * 600);\n  --sds-g-font-weight-7: var(--slds-g-font-weight-7);\n  --slds-g-font-weight-7: calc(var(--slds-g-font-weight-ratio) * 700);\n  --slds-g-font-lineheight-ratio: 1;\n  --sds-g-font-lineheight-base: var(--slds-g-font-lineheight-base);\n  --slds-g-font-lineheight-base: 1.5;\n  --sds-g-font-lineheight-1: var(--slds-g-font-lineheight-1);\n  --slds-g-font-lineheight-1: calc(var(--slds-g-font-lineheight-ratio) * 1);\n  --sds-g-font-lineheight-2: var(--slds-g-font-lineheight-2);\n  --slds-g-font-lineheight-2: calc(var(--slds-g-font-lineheight-ratio) * 1.25);\n  --sds-g-font-lineheight-3: var(--slds-g-font-lineheight-3);\n  --slds-g-font-lineheight-3: calc(var(--slds-g-font-lineheight-ratio) * 1.375);\n  --sds-g-font-lineheight-4: var(--slds-g-font-lineheight-4);\n  --slds-g-font-lineheight-4: calc(var(--slds-g-font-lineheight-ratio) * 1.5);\n  --sds-g-font-lineheight-5: var(--slds-g-font-lineheight-5);\n  --slds-g-font-lineheight-5: calc(var(--slds-g-font-lineheight-ratio) * 1.75);\n  --sds-g-font-lineheight-6: var(--slds-g-font-lineheight-6);\n  --slds-g-font-lineheight-6: calc(var(--slds-g-font-lineheight-ratio) * 2);\n  --sds-g-font-scale-ratio: var(--slds-g-font-scale-ratio);\n  --slds-g-font-scale-ratio: 1;\n  --sds-g-font-size-base: var(--slds-g-font-size-base);\n  --slds-g-font-size-base: calc(var(--slds-g-font-scale-ratio) * 0.8125rem);\n  --sds-g-font-scale-neg-4: var(--slds-g-font-scale-neg-4);\n  --slds-g-font-scale-neg-4: var(--slds-g-font-scale-neg-3);\n  --sds-g-font-scale-neg-3: var(--slds-g-font-scale-neg-3);\n  --slds-g-font-scale-neg-3: var(--slds-g-font-scale-neg-2);\n  --sds-g-font-scale-neg-2: var(--slds-g-font-scale-neg-2);\n  --slds-g-font-scale-neg-2: calc(var(--slds-g-font-scale-ratio) * 0.625rem);\n  --sds-g-font-scale-neg-1: var(--slds-g-font-scale-neg-1);\n  --slds-g-font-scale-neg-1: calc(var(--slds-g-font-scale-ratio) * 0.75rem);\n  --sds-g-font-scale-1: var(--slds-g-font-scale-1);\n  --slds-g-font-scale-1: calc(var(--slds-g-font-scale-ratio) * 0.875rem);\n  --sds-g-font-scale-2: var(--slds-g-font-scale-2);\n  --slds-g-font-scale-2: calc(var(--slds-g-font-scale-ratio) * 1rem);\n  --sds-g-font-scale-3: var(--slds-g-font-scale-3);\n  --slds-g-font-scale-3: calc(var(--slds-g-font-scale-ratio) * 1.25rem);\n  --sds-g-font-scale-4: var(--slds-g-font-scale-4);\n  --slds-g-font-scale-4: calc(var(--slds-g-font-scale-ratio) * 1.5rem);\n  --sds-g-font-scale-5: var(--slds-g-font-scale-5);\n  --slds-g-font-scale-5: calc(var(--slds-g-font-scale-ratio) * 1.75rem);\n  --sds-g-font-scale-6: var(--slds-g-font-scale-6);\n  --slds-g-font-scale-6: calc(var(--slds-g-font-scale-ratio) * 2rem);\n  --sds-g-font-scale-7: var(--slds-g-font-scale-7);\n  --slds-g-font-scale-7: calc(var(--slds-g-font-scale-ratio) * 2.5rem);\n  --sds-g-font-scale-8: var(--slds-g-font-scale-8);\n  --slds-g-font-scale-8: calc(var(--slds-g-font-scale-ratio) * 3rem);\n  --sds-g-font-scale-9: var(--slds-g-font-scale-9);\n  --slds-g-font-scale-9: var(--slds-g-font-scale-8);\n  --sds-g-font-scale-10: var(--slds-g-font-scale-10);\n  --slds-g-font-scale-10: var(--slds-g-font-scale-8);\n\n  --slds-s-link-color: #0250d9;\n  --slds-s-link-color-hover: #022ac0;\n  --slds-s-link-color-focus: #022ac0;\n  --slds-s-link-color-active: #022ac0;\n\n  --sds-g-font-family: var(--slds-g-font-family);\n  --slds-g-font-family: var(--slds-g-font-family-base);\n  --sds-g-font-family-base: var(--slds-g-font-family-base);\n  --slds-g-font-family-base: system-ui, -apple-system, BlinkMacSystemFont, Segoe UI, Roboto, 'Helvetica Neue', Arial, sans-serif, 'Apple Color Emoji', 'Segoe UI Emoji', 'Segoe UI Symbol';\n\n}\n\n\n.site-options label {\n  font-size: var(--sds-g-font-scale-neg-3);\n  font-weight: 700;\n  text-transform: uppercase;\n  letter-spacing: 0.05em;\n}\n\n.search input {\n  background-color: var(--sds-g-color-surface-container-1);\n  border: 1px solid var(--sds-g-color-border-1);\n  width: 100%;\n  border-radius: var(--sds-g-radius-border-2);\n  padding: calc(var(--sds-g-spacing-1) + 1px) var(--sds-g-spacing-2);\n}\n\n.search input::placeholder {\n  color: var(--sds-g-color-on-surface-1);\n}\n\n.search input:focus {\n  outline: none;\n  box-shadow: 0 0 2px var(--sds-g-color-accent-1);\n  border-color: var(--sds-g-color-border-accent-1);\n}\n\n.hidden {\n  display: none;\n}\n\nmain {\n  height: 100vh;\n  width: 100vw;\n  padding-top: var(--_header-height);\n\n  @media (min-width: 768px) {\n    display: grid;\n    grid-template-columns: var(--_rail-width) 1fr;\n    height: calc(100% - var(--_header-height));\n    padding: 0;\n  }\n}\n\n.source-btn {\n  display: inline-flex;\n  align-items: center;\n  border: 1px solid black;\n  font-size: var(--sds-g-font-scale-neg-1);\n  background-color: var(--sds-g-color-neutral-base-10);\n  color: var(--sds-g-color-neutral-base-100);\n  border-radius: var(--sds-g-radius-border-2);\n  padding-inline: var(--sds-g-spacing-3);\n  padding-block: var(--sds-g-spacing-1);\n  text-decoration: none;\n  gap: var(--sds-g-spacing-1);\n\n  --sds-c-icon-color-foreground: currentColor;\n}\n\n.canvas {\n  padding: var(--sds-g-spacing-4) var(--sds-g-spacing-6);\n  height: calc(100vh - var(--_header-height));\n  width: 100%;\n  overflow: auto;\n\n  @media (min-width: 768px) {\n    border-top-left-radius: var(--sds-g-radius-border-4);\n  }\n}\n\n.canvas :where(h1, h2, h3, h4, h5, h6) {\n  margin-block-start: var(--sds-g-spacing-3);\n  margin-block-end: var(--sds-g-spacing-4);\n  font-weight: 700;\n}\n\n.canvas h1 {\n  font-size: var(--sds-g-font-scale-4);\n  color: var(--sds-g-color-on-surface-3);\n}\n\n.canvas h2 {\n  font-size: var(--sds-g-font-scale-3);\n  color: var(--sds-g-color-on-surface-3);\n}\n\n.canvas h3 {\n  font-size: var(--sds-g-font-scale-2);\n  color: var(--sds-g-color-on-surface-3);\n}\n\n.canvas p:not([slot]) {\n  margin-block-start: var(--sds-g-spacing-2);\n  margin-block-end: var(--sds-g-spacing-4);\n}\n\n.canvas ol {\n  list-style: decimal;\n  padding-left: 1rem;\n  margin-bottom: var(--sds-g-spacing-4);\n}\n\n.canvas pre {\n  margin-block-start: var(--sds-g-spacing-2);\n  margin-block-end: var(--sds-g-spacing-4);\n  padding: var(--sds-g-spacing-4);\n  border-radius: var(--sds-g-radius-border-3);\n  font-size: var(--sds-g-font-scale-neg-1);\n  max-width: calc(100vw - var(--sds-g-spacing-6) * 2);\n\n  @media (min-width: 768px) {\n    max-width: 120ch;\n  }\n}\n\n.page-header {\n  text-transform: capitalize;\n  padding-block-end: var(--sds-g-spacing-4);\n  margin-block-end: var(--sds-g-spacing-4);\n\n  @media (min-width: 768px) {\n    display: flex;\n    align-items: center;\n    gap: 1.62rem;\n  }\n}\n\n.page-header h2 {\n  margin-inline-end: auto;\n  margin-block: 0;\n  font-size: var(--sds-g-font-scale-5);\n}\n\n.mobile-menu {\n  display: none;\n}\n\n@media (max-width: 768px) {\n  .header {\n    position: fixed;\n    top: 0;\n    left: 0;\n    right: 0;\n    background-color: var(--sds-g-color-surface-1);\n  }\n\n  .header-right {\n    display: none;\n  }\n\n  .mobile-menu {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    position: relative;\n    z-index: 3;\n    width: 40px;\n    height: 40px;\n    padding: 0;\n    border: 0;\n    background-color: transparent;\n    cursor: pointer;\n    flex: 0 0 auto;\n    margin-inline-start: auto;\n  }\n}\n\n.site-rail {\n  display: flex;\n  flex-direction: column;\n  padding: var(--sds-g-spacing-4) var(--sds-g-spacing-4) 0;\n  height: calc(100vh - var(--_header-height));\n\n  @media (max-width: 768px) {\n    position: fixed;\n    top: var(--_header-height);\n    right: 0;\n    width: 80vw;\n    height: calc(100vh - var(--_header-height));\n    z-index: 2;\n    background-color: var(--sds-g-color-surface-1);\n    transform: translateX(100%);\n    box-shadow: var(--sds-g-shadow-4);\n    transition: transform 0.2s ease-in-out;\n  }\n}\n\n.nav {\n  display: flex;\n  flex-direction: column;\n  padding: 0 var(--sds-g-spacing-4) var(--sds-g-spacing-4);\n  overflow-y: auto;\n  margin-inline: calc(var(--sds-g-spacing-4) * -1);\n}\n\n.nav-open .site-rail {\n  transform: translateX(0);\n}\n\n.nav>p {\n  margin-block-start: var(--sds-g-spacing-4);\n  margin-block-end: var(--sds-g-spacing-4);\n  font-weight: 700;\n  color: var(--sds-g-color-on-surface-3);\n}\n\n.nav li {\n  border-radius: var(--sds-g-radius-border-3);\n}\n\n.nav li+li {\n  margin-block-start: var(--sds-g-spacing-2);\n}\n\n.nav a {\n  display: block;\n  padding: var(--sds-g-spacing-2) var(--sds-g-spacing-4);\n  color: var(--sds-g-color-on-surface-2);\n  text-decoration: none;\n  border-radius: var(--sds-g-radius-border-3);\n  transition: background-color 0.2s ease-in-out;\n}\n\n.nav a:hover {\n  background-color: var(--sds-g-color-surface-3);\n}\n\n.nav .active,\n.nav .active a {\n  background-color: var(--sds-g-color-surface-1);\n}\n\n/*\n * ------------------\n * Styling Hook Stuff\n * ------------------\n */\n.styling-hooks :where(h2, h3, h4) {\n  margin-block-start: var(--sds-g-spacing-6);\n  margin-block-end: var(--sds-g-spacing-4);\n}\n\n.styling-hooks :where(h1, h2, h3, h4) {\n  color: light-dark(#000, #fff);\n}\n\n.ui-colors [data-value] {\n  --shadow1: light-dark(#18181808, #78727208);\n  --shadow2: light-dark(#18181810, #ada0a015);\n  --shadow3: light-dark(#18181815, #ada0a015);\n  border-radius: 8px;\n  box-shadow: 0px 3px 5px -2px var(--shadow1), 0px 7px 14px -5px var(--shadow2), 0 0 0 1px inset var(--shadow3);\n  display: flex;\n  flex-direction: column;\n  gap: 0.25rem;\n  align-items: center;\n  justify-content: center;\n  text-align: center;\n  font-size: var(--sds-g-font-scale-neg-3);\n  font-family: var(--sds-g-font-family-monospace);\n}\n\n/* Surface Colors */\n.surface-colors {\n  display: grid;\n  grid-template-columns: repeat(6, minmax(var(--sds-g-sizing-10), 1fr));\n  grid-template-rows: repeat(3, var(--sds-g-sizing-11));\n  gap: 1rem;\n}\n\n.surface-colors .on-surface {\n  grid-row-start: 1;\n  grid-column: 1 / span 6;\n  display: grid;\n  grid-template-columns: repeat(5, minmax(0, 1fr));\n  gap: 1rem;\n}\n\n.surface-colors .surfaces {\n  grid-row-start: 3;\n  grid-column: 1 / span 6;\n  display: grid;\n  grid-template-columns: repeat(3, minmax(0, 1fr));\n  gap: 1rem;\n}\n\n.surface-colors .surface-containers {\n  grid-row-start: 2;\n  grid-column: 1 / span 6;\n  display: grid;\n  grid-template-columns: repeat(3, minmax(0, 1fr));\n  gap: 1rem;\n}\n\n/* Accents Colors */\n.accent-colors {\n  display: grid;\n  grid-template-columns: repeat(4, minmax(var(--sds-g-sizing-10), 1fr));\n  /* grid-template-rows: repeat(4, var(--sds-g-sizing-11)); */\n  gap: 1rem;\n}\n\n.accent-colors>div {\n  display: flex;\n  flex-direction: column;\n  gap: 1rem;\n}\n\n.accent-colors [data-value] {\n  flex: 0 0 var(--sds-g-sizing-11);\n}\n\n/* Feedback Colors */\n.feedback-colors {\n  display: grid;\n  grid-template-columns: repeat(4, minmax(var(--sds-g-sizing-10), 1fr));\n  gap: 1rem;\n}\n\n.feedback-colors>div {\n  display: flex;\n  flex-direction: column;\n  gap: 1rem;\n}\n\n.feedback-colors p {\n  font-size: var(--sds-g-font-scale-neg-2);\n}\n\n.feedback-colors [data-value] {\n  flex: 0 0 var(--sds-g-sizing-11);\n}\n\n/* Element Colors */\n.element-colors {\n  display: grid;\n  grid-template-columns: repeat(4, minmax(0, 1fr));\n  gap: 1rem;\n}\n\n.element-colors>div {\n  display: flex;\n  flex-direction: column;\n  gap: 1rem;\n}\n\n.element-colors [data-value] {\n  flex: 0 0 var(--sds-g-sizing-11);\n}\n\n/* System Colors */\n.system-colors [data-value],\n.color-palettes [data-value] {\n  border-radius: 8px;\n  box-shadow: var(--sds-g-shadow-2), 0 0 0 1px inset #18181815;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  text-align: center;\n  padding: 0 var(--sds-g-spacing-2);\n  font-size: var(--sds-g-font-scale-neg-3);\n  font-family: var(--sds-g-font-family-monospace);\n  aspect-ratio: var(--sds-g-ratio-square);\n\n  @media (min-width: 768px) {\n    aspect-ratio: var(--sds-g-ratio-landscape);\n  }\n\n  @media (min-width: 1024px) {\n    aspect-ratio: var(--sds-g-ratio-square);\n  }\n}\n\n.system-colors {\n  display: grid;\n  grid-template-columns: repeat(6, minmax(0, 1fr));\n  gap: 1rem;\n\n  @media (min-width: 1280px) {\n    grid-template-columns: repeat(13, minmax(0, 1fr));\n  }\n}\n\n.system-colors.feedback {\n  grid-template-columns: repeat(5, minmax(0, 1fr));\n\n  @media (min-width: 1024px) {\n    grid-template-columns: repeat(10, minmax(0, 1fr));\n  }\n}\n\n/* Color Palettes */\n.color-palettes {\n  display: grid;\n  grid-template-columns: repeat(6, minmax(0, 1fr));\n  gap: 1rem;\n  margin-block: 1rem;\n\n  @media (min-width: 1024px) {\n    grid-template-columns: repeat(12, minmax(0, 1fr));\n  }\n}\n\n/* Shadows, Border Widths, Border Radius */\n.shadow,\n.border-width {\n  display: flex;\n  gap: 1rem;\n}\n\n.border-radius {\n  display: grid;\n  grid-template-columns: repeat(5, 1fr);\n  grid-template-rows: 1fr var(--sds-g-sizing-9);\n  gap: 1rem;\n}\n\n.shadow [data-value],\n.border-width [data-value],\n.border-radius [data-value] {\n  background: var(--sds-g-color-surface-container-1);\n  border-radius: 8px;\n  display: flex;\n  flex-direction: column;\n  gap: 0.125rem;\n  align-items: center;\n  justify-content: center;\n  text-align: center;\n  flex: 1;\n  font-size: var(--sds-g-font-scale-neg-3);\n  font-family: var(--sds-g-font-family-monospace);\n  aspect-ratio: var(--sds-g-ratio-square);\n}\n\n.shadow [data-value],\n.border-width [data-value] {\n  @media (min-width: 1280px) {\n    aspect-ratio: var(--sds-g-ratio-landscape);\n  }\n}\n\n.border-width div,\n.border-radius div {\n  border: 1px solid var(--sds-g-color-border-1);\n}\n\n.border-radius .border-pill {\n  height: var(--sds-g-sizing-9);\n  aspect-ratio: unset;\n}\n\n/* Font */\n.line-height>p {\n  max-inline-size: var(--sds-g-sizing-content-2);\n}\n\n.font-size [data-value] {\n  line-height: 1.15;\n}\n\n.font-size [data-value],\n.font-weight [data-value],\n.line-height [data-value] {\n  display: grid;\n  grid-template-columns: minmax(max-content, 100px) 1fr;\n  gap: 1rem;\n  margin-block: var(--sds-g-spacing-2);\n}\n\n.font-size [data-value]:before,\n.font-weight [data-value]:before,\n.line-height [data-value]:before {\n  content: attr(data-size);\n  font-size: var(--sds-g-font-scale-neg-3);\n  font-family: var(--sds-g-font-family-monospace);\n  font-weight: normal;\n  text-align: right;\n  align-self: center;\n}\n\n/* Spacing, Sizing */\n.spacing [data-value],\n.sizing [data-value] {\n  display: grid;\n  grid-template-columns: minmax(max-content, 100px) 1fr;\n  gap: 1rem;\n  margin-block: var(--sds-g-spacing-2);\n}\n\n.spacing [data-value]:before,\n.sizing [data-value]:before {\n  content: attr(data-size);\n  font-size: var(--sds-g-font-scale-neg-3);\n  font-family: var(--sds-g-font-family-monospace);\n  font-weight: normal;\n  text-align: right;\n  align-self: center;\n}\n\n.spacing [data-value]>div,\n.sizing [data-value]>div {\n  background-color: var(--sds-g-color-surface-container-3);\n}\n\n/* Content Sizing */\n.content-sizing {\n  display: grid;\n  grid-template-columns: repeat(1, minmax(0, 1fr));\n\n  @media (min-width: 1024px) {\n    grid-template-columns: repeat(3, minmax(0, 1fr));\n  }\n}\n\n.content-sizing>div {\n  display: flex;\n  flex-direction: column;\n  gap: 1rem;\n}\n\n.content-sizing>div:before {\n  content: attr(data-prop) ' : ' attr(data-size);\n  font-size: var(--sds-g-font-scale-neg-3);\n  font-family: var(--sds-g-font-family-monospace);\n}\n\n.byline {\n  display: flex;\n  flex-direction: column;\n}\n\n.byline_title {\n  font-size: var(--sds-g-font-scale-neg-3);\n  font-weight: 700;\n  text-transform: uppercase;\n  letter-spacing: 0.05em;\n}\n\n.byline [title] {\n  text-decoration: underline dotted;\n  cursor: help;\n}\n\n.byline a {\n  color: var(--sds-g-color-accent-2);\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
